import { render, staticRenderFns } from "./BudgetRightHeader.vue?vue&type=template&id=36b75977&"
import script from "./BudgetRightHeader.vue?vue&type=script&lang=js&"
export * from "./BudgetRightHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports